"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateCallback = void 0;
const react_1 = require("react");
/**
 * This allows you to pass a second parameter to the setState function which
 * will be called once the component has re-rendered
 *
 * @warning The callback will be called even if the setState is cancelled, and
 *          this is therefore not safe to call from render
 *
 */
const useStateCallback = (initialValue) => {
    const [state, setState] = (0, react_1.useState)(initialValue);
    const callbacksRef = (0, react_1.useRef)([]);
    const updateRef = (0, react_1.useRef)((nextState, callback) => {
        if (callback) {
            callbacksRef.current.push(callback);
        }
        setState(nextState);
    });
    (0, react_1.useLayoutEffect)(() => {
        for (const callback of callbacksRef.current) {
            callback();
        }
        callbacksRef.current = [];
    });
    return [state, updateRef.current];
};
exports.useStateCallback = useStateCallback;
